import PropTypes from "prop-types";

/*
    Representation of src/ssaw/portal/template_serializers/modules/product_image_card.py
*/
export const ProductImageCardPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    product_slug: PropTypes.string.isRequired,
    url: PropTypes.string,
    lead_url: PropTypes.string,
    is_affiliate: PropTypes.bool.isRequired,
    context_type: PropTypes.string,
    image_url: PropTypes.string,
    image_width: PropTypes.number,
    image_height: PropTypes.number.isRequired,
    image_alt_text: PropTypes.string.isRequired,
});
